import PricingPlanCard from './PricingPlanCard'

export default PricingPlanCard
